var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"Path_2282","d":"M0,0H24V24H0Z","fill":"none","key":0}),React.createElement("path",{"id":"Path_2401","data-name":"Path 2401","d":"M1242.188-971.128l-7.712-7.517,1.047-1.074,6.652,6.483,11.295-11.295,1.061,1.061Z","transform":"translate(-1232.477 990.182)","fill":"#0f0f0f","key":1})]);
}

Check.defaultProps = {"id":"icon_check","data-name":"icon / check","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Check;

Check.default = Check;
